import { get, post } from '../utils/request';

// 保存紧急服务接口
export const saveEmergencyService = (params: any) => {
  return post<any>('/emergency_service/save_emergency_service', params);
};

// 根据当前位置获取附近紧急服务列表 未登录
export const getEmergencyServiceListByDistance = (params: any) => {
  return get<any>('/emergency_service/get_emergency_service_list_by_distance', params);
};
// 根据当前位置获取附近紧急服务列表 已登录
export const getEmergencyServiceListByDistanceLogin = (params: any) => {
  return get<any>('/emergency_service/get_emergency_service_list_by_distance', params);
};

// 获取紧急服务订单列表
export const getEmergencyServiceList = (params: any) => {
  return get<any>('/emergency_service/get_emergency_service_list', params)
}
// 获取紧急服务候选人订单列表
export const getBiddingList = (params: any) => {
  return get<any>('/emergency_service/get_bidding_list', params)
}
// 确定紧急服务候选人
export const selectWinner = (params: any) => {
  return post<any>('/emergency_service/select_winner', params)
}

// 根据ID获取紧急服务详情
export const getEmergencyServiceById = (params: any) => {
  return get<any>('/emergency_service/get_emergency_service_by_id', params);
};

// 手机号验证
export const phoneVerification = (params: any) => {
  return post<any>('/user/get_phone_verification_code', params);
};

// 手机验证码校验
export const phoneVerificationCodeLogin = (params: any) => {
  return post<any>('/user/save_phone_verification_code_login', params);
};

// 接单者参与竞价或者接单
export const saveEmergencyServiceBidding = (params: any) => {
  return post<any>('/emergency_service/save_emergency_service_bidding', params);
};


// user/get_vip_price
// 获取会员价格
export const getVipPrice = (params: any) => {
  return get<any>('/user/get_vip_price', params);
};

// 保存用户会员
export const saveUserVip = (params: any) => {
  return post<any>('/user/save_user_vip', params);
};


// 获取会员信息字段
export const getUserProfile = () => {
  return get<any>('/user/get_user_profile');
};

// ========== 新增接口 ==========

// 发送邮件验证码
export const getEmergencyEmailVerificationCode = (params: any) => {
  return post<any>('/emergency_service/get_emergency_phone_verification_code', params);
};

// 验证码验证并发布服务
export const saveEmergencyServiceWithVerification = (params: any) => {
  return post<any>('/emergency_service/save_emergency_service', params);
};

// 获取首页快要结束的紧急服务（3个）
export const getEmergencyServiceEndingSoon = (params: any) => {
  return get<any>('/emergency_service/get_emergency_service_ending_soon', params);
};

// 获取所有快要结束的紧急服务（View More）
export const getEmergencyServiceEndingSoonAll = (params: any) => {
  return get<any>('/emergency_service/get_emergency_service_ending_soon_all', params);
};

// 获取所有已发布的紧急服务
export const getAllPublishedEmergencyServices = (params: any) => {
  return get<any>('/emergency_service/get_recommended_services', params);
};